"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeridiemFull = exports.getMeridiemLowerCase = exports.getMeridiemUpperCase = void 0;
var get_localised_date_property_1 = require("../utils/get-localised-date-property");
var getMeridiem = function (params) {
    return get_localised_date_property_1.getLocalisedDateProperty({
        date: params.date,
        languageTag: params.languageTag,
        ianaTimeZoneName: params.ianaTimeZoneName,
        property: 'dayPeriod',
        format: 'numeric'
    });
};
/**
 * Returns the localised meridiem string in upper case: AM, PM
 * @hidden
 */
var getMeridiemUpperCase = function (params) {
    return getMeridiem(params).toUpperCase();
};
exports.getMeridiemUpperCase = getMeridiemUpperCase;
/**
 * Returns the localised meridiem string in lower case: am, pm
 * @hidden
 */
var getMeridiemLowerCase = function (params) {
    return getMeridiem(params).toLowerCase();
};
exports.getMeridiemLowerCase = getMeridiemLowerCase;
/**
 * (Not supported) Returns the 'full' meridiem string: a.m., p.m.
 * The MeridiemFull ("aa") format is supported by date-fns, but is not supported by the Intl API.
 * This method is here to communicate this breaking change to consumers of the i18n package.
 * @hidden
 */
var getMeridiemFull = function () {
    throw new Error('MeridiemFull format ("aa") not supported');
};
exports.getMeridiemFull = getMeridiemFull;
//# sourceMappingURL=meridiem.js.map